import { render, staticRenderFns } from "./topo-instance-dependency.vue?vue&type=template&id=3342b048&"
import script from "./topo-instance-dependency.vue?vue&type=script&lang=ts&"
export * from "./topo-instance-dependency.vue?vue&type=script&lang=ts&"
import style0 from "./topo-instance-dependency.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports